import React from "react";
import { Modal } from "antd";
import DonutChartView from "./Table";

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function DonutChartDetailsModal({ open, onClose }: Props) {
  return (
    <Modal
      title="Donut chart - Spider layout tags"
      open={open}
      onCancel={onClose}
      footer={null}
      width={870}
      centered
    >
      <DonutChartView />
    </Modal>
  );
}
